function dcg_AB ( name , value , callback ) {
    value = value || '' ;
    callback = callback || function () { } ;

    var url = SETUP_INDEX + '?module=abtest'  ;

    url += '&index[abtest][action]=track' ;
    url += '&index[abtest][skipMainTemplate]=TRUE' ;
    url += '&index[abtest][name]=' + name ;
    url += '&index[abtest][value]=' + value ;
    url += '&token=' + CSRF_TOKEN ;
    url += '&ajax=TRUE' ;

    return $.ajax ( {
                url : url,
                type: 'GET',
                success : callback
            } ) ;
}

$( document ).on ( 'areaReady' , function ( event ) {
    $( '.track-ab' , event.target ).click ( function ( e ) {    
        var element = $( this ) ;

        if ( element.is ( 'a' ) ) {
            e.preventDefault () ;  
        }
           
        var name = $( this ).attr ( 'data-ab-name' ) ;

        if ( typeof name == typeof undefined || name == false ) {
            return true ;
        }

        var value = $( this ).attr ( 'data-ab-value' ) ;  
        
        if ( typeof value == typeof undefined || value == false ) {
            value = '' ;
        }
        
        dcg_AB ( name , value , function () {
            if ( element.is ( 'a' ) ) {
                document.location.href = element.attr ( 'href' ) ;      
            }
        } ) ;
    } );
    
    $( '.set-ab' , event.target ).click ( function () {
        var test_id = $( this ).attr ( 'data-ab-test_id' ) ;
        var variant_id = $( this ).attr ( 'data-ab--variant_id' ) ;


        dcg_ExecuteModule ( 'abtest' , { action: 'settest' , test_id: test_id , variant_id : variant_id } , function () {
            document.location.reload () ;
        } ) ;
    } ) ;
} ) ;